import { SchemaNode } from '@stoplight/json-schema-tree';
import { Box, SpaceVals } from '@stoplight/mosaic';
import type { ChangeType } from '@stoplight/types';
import * as React from 'react';

import { NESTING_OFFSET } from '../../consts';
import { useJSVOptionsContext } from '../../contexts';
// import { SchemaRow, SchemaRowProps } from '../SchemaRow';
import { SelectedVariableType } from '..';
import { SchemaSourceType } from '../../../graph/nodes-config/CustomJsonSchemaField';
import { SchemaRowProps } from '../shared/SharedTypes';

type ChildStackProps = {
  schemaNode: SchemaNode;
  childNodes: readonly SchemaNode[];
  currentNestingLevel: number;
  className?: string;
  parentNodeId?: string;
  RowComponent?: React.FC<SchemaRowProps>;
  parentChangeType?: ChangeType;
  sourceSchemaDestination?: SchemaSourceType;
  previousNodeId?: string;
  selectedVariable: SelectedVariableType;
  setSelectedVariable: React.Dispatch<React.SetStateAction<SelectedVariableType>>;
};

export const ChildStack = React.memo(
  ({
    childNodes,
    currentNestingLevel,
    className,
    RowComponent = () => null,
    parentNodeId,
    parentChangeType,
    sourceSchemaDestination,
    previousNodeId,
    selectedVariable,
    setSelectedVariable
  }: ChildStackProps) => {
    const { renderRootTreeLines } = useJSVOptionsContext();
    const rootLevel = renderRootTreeLines ? 0 : 1;
    const isRootLevel = currentNestingLevel < rootLevel;

    let ml: SpaceVals | undefined;
    if (!isRootLevel) {
      ml = currentNestingLevel === rootLevel ? 'px' : 7;
    }

    return (
      <Box
        className={className}
        ml={ml}
        fontSize="sm"
        borderL={isRootLevel ? undefined : true}
        data-level={currentNestingLevel}
      >
        {childNodes.map((childNode: SchemaNode) => (
          <RowComponent
            key={childNode.id}
            schemaNode={childNode}
            nestingLevel={currentNestingLevel + 1}
            pl={isRootLevel ? undefined : NESTING_OFFSET}
            parentNodeId={parentNodeId}
            parentChangeType={parentChangeType}
            sourceSchemaDestination={sourceSchemaDestination}
            previousNodeId={previousNodeId}
            selectedVariable={selectedVariable}
            setSelectedVariable={setSelectedVariable}
          />
        ))}
      </Box>
    );
  },
);
